import {defineStore} from 'pinia';
import {ModuleJusticeCaseType} from '../moduleConst';
import justiceCaseTypeAPI from '@/apis/di/justiceCaseTypeAPI';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
const justiceCaseTypeStore = new BaseDictionaryStore(justiceCaseTypeAPI);
export const useJusticeCaseTypeStore = defineStore(ModuleJusticeCaseType, {
  state: () => ({
    ...justiceCaseTypeStore.state,
    _config: {
      key: 'justice_case_type_id',
      code: 'justice_case_type_alias',
      name: 'justice_case_type_name',
      table: 'di_justice_case_type',
      quickFollow: 'active',
      moduleName: 'Loại án',
      columns: 'justice_case_type_id,justice_case_type_alias,justice_case_type_name,active',
    },
    moduleName: 'diJusticeCaseType',
  }),
  actions: {...justiceCaseTypeStore.action},
  getters: {
    ...justiceCaseTypeStore.getters,
  },
});
